export enum PermissionEnum {
    PROJECT_READ = 'project:read',
    PROJECT_CREATE = 'project:create',
    PROJECT_UPDATE = 'project:update',
    PROJECT_DELETE = 'project:delete',

    PROJECT_REPORT_READ = 'project_report:read',
    PROJECT_REPORT_CREATE = 'project_report:create',
    PROJECT_REPORT_UPDATE = 'project_report:update',
    PROJECT_REPORT_DELETE = 'project_report:delete',

    CAMERA_READ = 'camera:read',
    CAMERA_CREATE = 'camera:create',
    CAMERA_UPDATE = 'camera:update',

    CAMERA_CCTV_READ = 'camera_cctv:read',
    CAMERA_CCTV_CREATE = 'camera_cctv:create',
    CAMERA_CCTV_UPDATE = 'camera_cctv:update',

    DRONE_READ = 'drone:read',
    DRONE_CREATE = 'drone:create',
    DRONE_UPDATE = 'drone:update',
    DRONE_DELETE = 'drone:delete',
    DRONE_SHARE = 'drone:share',

    SITE_GALLERY_READ = 'site_gallery:read',
    SITE_GALLERY_CREATE = 'site_gallery:create',
    SITE_GALLERY_UPDATE = 'site_gallery:update',
    SITE_GALLERY_DELETE = 'site_gallery:delete',
    SITE_GALLERY_SHARE = 'site_gallery:share',

    USER_READ = 'user:read',
    USER_CREATE = 'user:create',
    USER_UPDATE = 'user:update',
    USER_DELETE = 'user:delete',

    USER_INVITATION_READ = 'user_invitaion:read',
    USER_INVITATION_CREATE = 'user_invitaion:create',
    USER_INVITATION_UPDATE = 'user_invitaion:update',
    USER_INVITATION_DELETE = 'user_invitaion:delete',

    LIVELAPSE_READ = 'livelapse:read',
    LIVELAPSE_CREATE = 'livelapse:create',
    LIVELAPSE_UPDATE = 'livelapse:update',
    LIVELAPSE_DELETE = 'livelapse:delete',

    MULTIIMAGE_READ = 'multiimage:read',
    MULTIIMAGE_CREATE = 'multiimage:create',
    MULTIIMAGE_UPDATE = 'multiimage:update',
    MULTIIMAGE_DELETE = 'multiimage:delete',

    PROGRESSLINE_READ = 'progressline:read',
    PROGRESSLINE_CREATE = 'progressline:create',
    PROGRESSLINE_UPDATE = 'progressline:update',
    PROGRESSLINE_DELETE = 'progressline:delete',

    CAMERA_COMPARE_READ = 'camera_compare:read',

    PROGRESS_SLIDER_READ = 'progress_slider:read',

    CAMERA_INTEGRATION_READ = 'camera_integration:read',
    CAMERA_INTEGRATION_CREATE = 'camera_integration:create',
    CAMERA_INTEGRATION_UPDATE = 'camera_integration:update',
    CAMERA_INTEGRATION_DELETE = 'camera_integration:delete',

    CAMERA_REPORT_READ = 'camera_report:read',
    CAMERA_REPORT_CREATE = 'camera_report:create',
    CAMERA_REPORT_UPDATE = 'camera_report:update',
    CAMERA_REPORT_DELETE = 'camera_report:delete',

    CAMERA_IMAGE_READ = 'camera_image:read',
    CAMERA_IMAGE_DOWNLOAD = 'camera_imahe:download',
    CAMERA_IMAGE_SHARE = 'camera_image:share',

    CAMERA_IMAGE_COMMENT_READ = 'camera_image_comment:read',
    CAMERA_IMAGE_COMMENT_CREATE = 'camera_image_comment:create',
    CAMERA_IMAGE_COMMENT_UPDATE = 'camera_image_comment:update',
    CAMERA_IMAGE_COMMENT_DELETE = 'camera_image_comment:delete',
    CAMERA_IMAGE_COMMENT_CLOSE = 'camera_image_comment:close',

    PRINTSHOT_READ = 'printshot:read',

    DOCUMENT_READ = 'document:read',
    DOCUMENT_CREATE = 'document:create',
    DOCUMENT_UPDATE = 'document:update',
    DOCUMENT_DELETE = 'document:delete',

    PROJECT_LINK_READ = 'project_link:read',
    PROJECT_LINK_CREATE = 'project_link:create',
    PROJECT_LINK_UPDATE = 'project_link:update',
    PROJECT_LINK_DELETE = 'project_link:delete',

    PLUGINS_READ = 'plugins:read',
    PLUGINS_CREATE = 'plugins:create',
    PLUGINS_UPDATE = 'plugins:update',
    PLUGINS_DELETE = 'plugins:delete',

    AUTODESK_INTEGARTION_READ = 'autodesk_integration:read',
    AUTODESK_INTEGARTION_CREATE = 'autodesk_integration:create',
    AUTODESK_INTEGARTION_UPDATE = 'autodesk_integration:update',
    AUTODESK_INTEGARTION_DELETE = 'autodesk_integration:delete',

    IFRAME_INTEGRATION_READ = 'iframe_integration:read',
    IFRAME_INTEGRATION_CREATE = 'iframe_integration:create',
    IFRAME_INTEGRATION_UPDATE = 'iframe_integration:update',
    IFRAME_INTEGRATION_DELETE = 'iframe_integration:delete',

    SUPPORT_TICKET_READ = 'support_ticket:read',
    SUPPORT_TICKET_CREATE = 'support_ticket:create',
    SUPPORT_TICKET_UPDATE = 'support_ticket:update',
    SUPPORT_TICKET_DELETE = 'support_ticket:delete',

    CLIENT_READ = 'client:read',
    CLIENT_CREATE = 'client:create',
    CLIENT_UPDATE = 'client:update',

    STORAGE_INTEGRATION_READ = 'storage_integration:read',
    STORAGE_INTEGRATION_CREATE = 'storage_integration:create',
    STORAGE_INTEGRATION_UPDATE = 'storage_integration:update',
    STORAGE_INTEGRATION_DELETE = 'storage_integration:delete',

    SOCIAL_SHARE_UPDATE = 'social_share:update',

    GRIDWALL_READ = 'gridwall:read',
    GRIDWALL_REQUEST = 'gridwall:request',
    GRIDWALL_CREATE = 'gridwall:create',
    GRIDWALL_UPDATE = 'gridwall:update',
    GRIDWALL_DELETE = 'gridwall:delete',

    PUBLIC_INGESTION_API_READ = 'public_ingestion_api:read',
    PUBLIC_INGESTION_API_CREATE = 'public_ingestion_api:create',
    PUBLIC_INGESTION_API_UPDATE = 'public_ingestion_api:update',
    PUBLIC_INGESTION_API_DELETE = 'public_ingestion_api:delete',

    PUBLIC_API_READ = 'public_api:read',
    PUBLIC_API_CREATE = 'public_api:create',
    PUBLIC_API_UPDATE = 'public_api:update',
    PUBLIC_API_DELETE = 'public_api:delete',
}
